import React, { useEffect, useState } from 'react';
import { normalizeId } from '../helpers/utility';
import Image from '../../components/common/Image';

const ImageInput = field => {
  const { id, title, key, required, multiple = true, preValue, disabled, containerClassName = '', ...rest } = field;

  const inputId = id || normalizeId(title);
  const [images, setImages] = useState(Array.isArray(preValue) ? preValue : preValue ? [preValue] : []);

  useEffect(() => {
    if (Array.isArray(preValue)) {
      setImages(preValue);
    } else if (preValue) {
      setImages([preValue]);
    }
  }, [preValue]);

  const handleImagesChange = newImages => {
    setImages(newImages);
  };

  return (
    <>
      <Image
        images={images}
        onImagesChange={handleImagesChange}
        multiple={multiple}
        isEditMode={!disabled}
        containerClassName={containerClassName}
        showTitle={false}
        {...rest}
      />
      <input
        type="hidden"
        id={inputId}
        name={inputId}
        required={required}
        value={images && images.length ? JSON.stringify(images) : ''}
        readOnly
      />
    </>
  );
};

export default ImageInput;
